/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Position_Bottom_Left_TitleInputs */



/**
* | output |
* | --- |
* | "Position: Bottom Left" |
*
* @param {Position_Bottom_Left_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const position_bottom_left_title = /** @type {((inputs?: Position_Bottom_Left_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Position_Bottom_Left_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Position : En Bas a Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Position: Unten links")
	if (locale === "it") return /** @type {LocalizedString} */ ("Posizione: in basso a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позиция: Нижний левый угол")
	if (locale === "es") return /** @type {LocalizedString} */ ("Posición: Abajo a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("位置：左下角")
	if (locale === "ja") return /** @type {LocalizedString} */ ("位置: 左下")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्थिति: नीचे बाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Posição: Inferior Esquerda")
	return /** @type {LocalizedString} */ ("Position: Bottom Left")
});